<template>
  <div class="default-layout-container">
    <div class="content-container-1140">
      <h1>{{ pageContent.data[0]?.attributes.SolutionTitle }}</h1>
      <div class="content-two-columns d-flex">
        <div class="main-content">
          <div
            v-if="
              pageContent.data.length && 'attributes' in pageContent.data[0]
            "
            class="page-content md-content"
            v-html="
              md.render(pageContent.data[0]?.attributes.SolutionDescriptionHTML)
            "
          ></div>
          <div
            class="related-casestudies-container"
            v-if="
              pageContent.data[0]?.attributes.RelatedCaseStudies?.data?.length
            "
          >
            <template
              v-for="(casestudy, index) in pageContent.data[0].attributes
                .RelatedCaseStudies.data"
              :key="index"
            >
              <div class="case-study-image-wrapper">
                <nuxt-img
                  :src="casestudy.attributes.FeatureImage.data.attributes.url"
                  :alt="
                    casestudy.attributes.FeatureImage.data.attributes
                      .alternativeText
                  "
                ></nuxt-img>
              </div>
              <div class="case-study-content">
                <h3>{{ casestudy.attributes.PageTitle }}</h3>
                <p>{{ casestudy.attributes.Summary }}</p>
                <nuxt-link
                  class="btn-solid-yellow btn-solid"
                  :to="
                    localePath({
                      name: 'casestudy-CaseStudyURL',
                      params: { CaseStudyURL: casestudy.attributes.PageURL },
                    })
                  "
                >
                  {{ $t("solutions.viewCaseStudy") }}
                </nuxt-link>
              </div>
            </template>
          </div>
          <div
            v-if="pageContent.data[0]?.attributes.ReferencesContentHTML"
            class="solution-references-container references-container"
          >
            <hr />
            <div
              class="references-content"
              v-html="pageContent.data[0].attributes.ReferencesContentHTML"
            ></div>
          </div>
        </div>
        <div class="side-bar">
          <!-- sector and pathways links -->
          <nuxt-link
            v-if="
              pageContent.data.length && 'attributes' in pageContent.data[0]
            "
            :to="
              localePath({
                name: 'sector-PageURL',
                params: {
                  PageURL:
                    sectors[pageContent.data[0].attributes.SolutionSector].slug,
                },
              })
            "
            :class="`solutions-link ${pageContent.data[0].attributes.SolutionSector}-solutions`"
            ><v-icon
              :icon="`$${
                sectors[pageContent.data[0].attributes.SolutionSector].iconAlt
              }`"
            ></v-icon
            >{{
              sectors[pageContent.data[0].attributes.SolutionSector].name
            }}</nuxt-link
          >

          <nuxt-link
            v-if="
              pageContent.data.length && 'attributes' in pageContent.data[0]
            "
            class="btn-solid btn-solid-green"
            :to="
              localePath({
                name: 'explore-region-country-sector',
                params: {
                  region: 'SA',
                  country: $t('explorer.all'),
                  sector: $t(
                    `explorer.sectors.${pageContent.data[0].attributes.SolutionSector}.slug`
                  ),
                },
              })
            "
            external
            >{{
              $t("explorer.viewSectorPathways", {
                sector:
                  sectors[pageContent.data[0].attributes.SolutionSector].name,
              })
            }}</nuxt-link
          >
        </div>
      </div>
    </div>
  </div>

  <!-- related solutions -->
  <div
    class="related-solutions-container"
    v-if="
      pageContent.data.length &&
      pageContent.data[0]?.attributes.RelatedSolutions?.data?.length
    "
  >
    <div class="content-container-1140">
      <h2>{{ $t("solutions.relatedSolutions") }}</h2>
      <div class="related-solutions-block d-flex">
        <template
          v-for="(solution, index) in pageContent.data[0].attributes
            .RelatedSolutions.data"
          :key="index"
        >
          <div
            class="related-solutions-item"
            :class="(solution.attributes?.SolutionSector ?? '').toLowerCase()"
            :style="{
              'background-image': `url(${solution.attributes.SolutionImage.data.attributes.formats.medium.url})`,
              'background-size': 'cover',
            }"
          >
            <nuxt-link
              :to="
                localePath({
                  name: 'solutions-SolutionURL',
                  params: { SolutionURL: solution.attributes.SolutionURL },
                })
              "
              external
            >
              <v-icon
                :icon="`$${sectors[solution.attributes.SolutionSector].icon}`"
              ></v-icon>
              <div class="related-solutions-item-title">
                {{ solution.attributes.SolutionTitle }}
              </div>
            </nuxt-link>
          </div>
        </template>

        <div
          class="related-solutions-item d-flex justify-center align-center all-solutions"
        >
          <nuxt-link
            class="all-solutions-link"
            :to="localePath({ name: 'solutions_overview-sector' })"
            >{{ $t("explorer.sectors.all.solutionsTitle") }}</nuxt-link
          >
        </div>
      </div>
    </div>
  </div>
  <!-- end related solutions -->
</template>
<script setup lang="ts">
const { locale } = useI18n();
const { md } = useMarkdownIt();
const localePath = useLocalePath();
// const localeRoute = useLocaleRoute();
const route = useRoute();

const { sectors } = usePathwaysConfig();

// api content
const contentType = "solutions";
const key = `${contentType}_${locale.value}`;

// special case populate params not handled by getStrapiLink... manually add them to the API URL
const apiURL = `${getStrapiLink(contentType, {
  filters: { SolutionURL: { $eqi: route.params.SolutionURL } },
})}&populate[RelatedSolutions][fields][0]=SolutionSector&populate[RelatedSolutions][fields][1]=SolutionURL&populate[RelatedSolutions][fields][2]=SolutionTitle&populate[RelatedSolutions][populate][0]=SolutionImage&populate[RelatedCaseStudies][fields][0]=PageTitle&populate[RelatedCaseStudies][fields][1]=PageURL&populate[RelatedCaseStudies][fields][2]=Summary&populate[RelatedCaseStudies][populate][0]=FeatureImage`;
const { data: pageContent } = await useFetch(apiURL, {
  key: key,
  watch: false,
});

useHead({
  title: () => pageContent.value?.data[0]?.attributes?.SolutionTitle
})
</script>
<style lang="scss" scoped>
// Category Styles
.solutions-cat-filter-block {
  margin-bottom: 20px;
}
.solutions-link {
  font-size: 20px;
  font-weight: 500;
  color: #050505;
  text-decoration: none;
  display: flex;
  align-items: center;
  position: relative;
  width: fit-content;
  margin-bottom: 20px;
  border-bottom: 2px solid transparent;

  .v-icon {
    font-size: 1em;
    margin-right: 10px;
  }

  &:hover {
    border-color: #247775;
  }
}

// Tag Styles
.tags-link-container {
  display: flex;
  flex-wrap: wrap;
}
.tags-link {
  width: fit-content !important;
  border: 1px solid #247775;
  color: #247775;
  font-weight: 500;
  text-decoration: none;
  padding: 5px 20px;
  border-radius: 20px;
  margin-right: 20px;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.15;
}
.tags-link:hover {
  color: #ffffff;
  background-color: #247775;
}

// Related Solutions Styles
.related-solutions-container {
  background-color: #e8f7f4;
  padding: 70px 20px;

  h2 {
    font-family: "Hind";
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 25px;
  }
  .related-solutions-block {
    width: 100%;
    margin-left: -15px;
    margin-right: -15px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
      flex-direction: column;
    }
  }
  .related-solutions-item {
    width: calc(25% - 30px);
    margin: 15px;
    position: relative;
    aspect-ratio: 1.18;

    @media (max-width: 1023px) {
      width: calc(50% - 30px);
    }

    @media (max-width: 600px) {
      width: 100%;
    }

    .v-img {
      height: 100%;
      filter: brightness(0.6);
      transition: filter 0.3s ease-in-out;
    }

    .v-icon {
      height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      color: #050505;
      font-size: 20px;
    }
    :deep(.svg-inline--fa) {
      width: 24px;
      height: 24px;
    }
    .all-solutions-link,
    .related-solutions-item-title {
      font-size: 21px;
      line-height: 1.19em;
      font-weight: 700;
    }
    .related-solutions-item-title {
      position: absolute;
      top: 0px;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center; /* for vertical alignment */
      justify-content: center;
      text-align: center;
      color: #fff;
      padding: 20px;
    }
    .all-solutions-link {
      color: #247775;
      text-decoration: none;
    }
    .all-solutions-link:hover {
      text-decoration: underline;
    }
  }
  .related-solutions-item:not(.all-solutions)::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(
      0,
      0,
      0,
      0.4
    ); /* Adjust the 0.5 to control the level of darkening */
    z-index: 0;
    transition: background-color 0.3s ease-in-out;
  }
  .related-solutions-item:not(.all-solutions):hover::before {
    background: rgba(
      0,
      0,
      0,
      0.6
    ); /* Adjust the 0.5 to control the level of darkening */
  }

  // Color Variations
  .related-solutions-item.agriculture {
    .v-icon {
      background-color: #33a28f;
    }
  }
  .related-solutions-item.energy {
    .v-icon {
      background-color: #f1d76a;
    }
  }
  .related-solutions-item.waste {
    .v-icon {
      background-color: #cb5546;
    }
  }

  .related-solutions-item a:hover {
    .v-img {
      filter: brightness(0.4);
    }
  }
}

// Case Study Styles
.related-casestudies-container {
  position: relative;
  margin: 80px 0;

  @media (min-width: 1100px) {
    display: flex;
  }
}
.case-study-image-wrapper {
  margin: 0 !important;
  line-height: 0;
}
.case-study-content {
  background-color: #050505;
  color: #ffffff;
  padding: 30px !important;

  @media (min-width: 1100px) {
    float: none;
    max-width: none;
    padding: 0px;
    width: calc(1140px - 100%);
    margin-left: 100%;
    position: absolute;
    padding-left: 40px;
    margin-bottom: 0px;
    top: 50%;
    transform: translatey(-50%);
  }

  h3 {
    font-family: "Hind";
    font-size: 30px;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 30px;
    font-size: 18px;
  }
}
</style>
